'use client'

import { LinkHash } from '@/components/common/Link'

import styles from './ButtonSkipToContent.module.scss'

export const ButtonSkipToContent = () => (
  <LinkHash className={styles.container} hash='main-content'>
    Skip to content
  </LinkHash>
)
